import { configureStore } from "@reduxjs/toolkit";
import loaderReducer from "../reducers/loaderReducer";

export default configureStore({
  reducer: {
    loader: loaderReducer,
  },
});
